import type {DataExtension} from '../../../types';

const COMMERCE_ORDER_ALIAS = 'orderConfirmationCommerceOrder';

export const getDataExtension: DataExtension = (element, dynamoData) => {
  const data = dynamoData.getDataForElement(element);

  if (!data || Array.isArray(data) || !('database' in data) || !data.database) {
    return data;
  }

  const commerceOrder =
    (data && data.database && data.database[COMMERCE_ORDER_ALIAS]) || null;

  return {
    ...data,
    database: {
      commerceOrder,
    },
  };
};
